const scrollArrowTrig = document.querySelector("#hero-scroll-down");
const scrollToSection = document.querySelector("#home-start");

gsap.registerPlugin(ScrollToPlugin);

scrollArrowTrig.addEventListener("click", () => {
  gsap.to(window, {
    duration: 1.5,
    ease: "Power2.easeInOut",
    scrollTo: "#home-start"
  });
});

// !!!! BEGIN scroll-based animations

gsap.registerPlugin(ScrollTrigger);

// Begin video expand animation
const videoWrapper = document.querySelector(".bg-video-wrap");
const videoElement = document.querySelector(".bg-video");

function videoExpand() {
  let expandVideo = gsap.timeline({
    defaults: { ease: Power1.easeInOut, duration: 1.5 },
    paused: true,
    scrollTrigger: {
      trigger: "#video-exp-trigger",
      // markers: true,
      start: "top 40%",
      // events: onEnter onLeave onEnterBack onLeaveBack
      toggleActions: "play none play none",
      scrub: 2
    }
  });

  expandVideo
    .to(videoWrapper, { width: "100vw" })
    // .to(videoElement, { width: "30%" }, "<")
    .to(videoWrapper, { height: "102vh" }, "<");
  // .to(videoElement, { height: "30%" }, "<");
}

ScrollTrigger.saveStyles(videoWrapper, videoElement);
ScrollTrigger.matchMedia({
  // desktop
  "(min-width: 992px)": function () {
    videoExpand();
  }
});
// !!!! end scroll-based animations
// ###############################

// ###############################
// !!!! BEGIN custom video player

// Define UI variables
const videoPlayer = document.querySelector("[data-video-wrap]");
const video = videoPlayer.querySelector("[data-video-element]");
const pauseVideoTrigger = videoPlayer.querySelector("[data-video-pause]");

const bannerVideo = document.querySelector("[data-video-banner]");
const playVideoTrigger = document.querySelector("[data-video-play-trigger]");
// const playVideoMobileTrigger = document.querySelector('.home-video__mobile-trigger');
const playVideoCursor = document.querySelector("[data-video-cursor]");
const playButtonText = playVideoCursor.querySelector("div");

// Define event listeners
// video.addEventListener("mouseover", showCursorOnMove);
video.addEventListener("ended", closeVideo);

[videoPlayer, video, pauseVideoTrigger].forEach((item) => {
  item.addEventListener("click", pauseVideo);
});

[playVideoTrigger].forEach((item) => {
  item.addEventListener("click", playVideo);
});

//   Open up video modal
playVideoTrigger.addEventListener("click", openVideoModal);
videoPlayer.addEventListener("click", openVideoModal);

// DEFINE FUNCTIONS

// Play video function
function playVideo(e) {
  if (video.paused) {
    video.play();
    setTimeout(function () {
      hideCursor(playVideoCursor);
    }, 300);
    setTimeout(function () {
      showCursor(pauseVideoTrigger);
    }, 500);
  }
}

// Play video function
function pauseVideo(e) {
  if (video.paused === false) {
    video.pause();
    showCursor(playVideoCursor);
    hideCursor(pauseVideoTrigger);
  }
}

// Hide/show play cursor functions
function hideCursor(cursor) {
  cursor.classList.add("is--hidden");
}

function showCursor(cursor) {
  cursor.classList.remove("is--hidden");
}

// Close video when ended
function closeVideo() {
  if (video.paused === false) {
    video.pause();
  }
  videoPlayer.click();
}

function openVideoModal() {
  videoPlayer.classList.toggle("is--visible");
}

// !!!! end custom video player
// ###############################

// featured products slider
function slider1() {
  let splides = $(".product-slider");
  for (let i = 0, splideLength = splides.length; i < splideLength; i++) {
    new Splide(splides[i], {
      // Desktop on down
      perPage: 2.5,
      perMove: 1,
      focus: 0, // 0 = left and 'center' = center
      type: "slide", // 'loop' or 'slide'
      gap: "2px", // space between slides
      arrows: "slider", // 'slider' or false
      pagination: false, // 'slider' or false
      speed: 1250, // transition speed in miliseconds
      easing: 'cubic-bezier(0.25, 1, 0.5, 1)',
      flickPower: 150,
      dragAngleThreshold: 30, // default is 30
      autoWidth: false, // for cards with differing widths
      waitForTransition: false,
      updateOnMove: true,
      trimSpace: false, // true removes empty space from end of list
      breakpoints: {
        991: {
          // Tablet
          perPage: 3
        },
        767: {
          // Mobile Landscape
          perPage: 2
        },
        479: {
          // Mobile Portrait
          perPage: 1
        }
      }
    }).mount();
  }
}
slider1();

// featured blog posts slider
// function slider2() {
//   let splides = $(".home-posts-slider");
//   for (let i = 0, splideLength = splides.length; i < splideLength; i++) {
//     new Splide(splides[i], {
//       // Desktop on down
//       perPage: 2,
//       perMove: 1,
//       focus: 0, // 0 = left and 'center' = center
//       type: "slide", // 'loop' or 'slide'
//       gap: "2.93em", // space between slides
//       arrows: "slider", // 'slider' or false
//       pagination: false, // 'slider' or false
//       speed: 600, // transition speed in miliseconds
//       dragAngleThreshold: 30, // default is 30
//       autoWidth: false, // for cards with differing widths
//       rewind: false, // go back to beginning when reach end
//       rewindSpeed: 400,
//       waitForTransition: false,
//       updateOnMove: true,
//       trimSpace: false, // true removes empty space from end of list
//       breakpoints: {
//         991: {
//           // Tablet
//           perPage: 3,
//           gap: "2em" // space between slides
//         },
//         767: {
//           // Mobile Landscape
//           perPage: 2,
//           gap: "2em" // space between slides
//         },
//         479: {
//           // Mobile Portrait
//           perPage: 1,
//           gap: "2em" // space between slides
//         }
//       }
//     }).mount();
//   }
// }
// slider2();

// begin drag custom cursor for slider
var cursor = document.querySelector(".custom-cursor");
var cursorinner = document.querySelector(".custom-cursor__label");
var a = document.querySelectorAll("a");

document.addEventListener("mousemove", function (e) {
  var x = e.clientX;
  var y = e.clientY;
  cursor.style.transform = `translate3d(calc(${e.clientX}px - 50%), calc(${e.clientY}px - 50%), 0)`;
});

document.addEventListener("mousemove", function (e) {
  var x = e.clientX;
  var y = e.clientY;
  cursorinner.style.left = x + "px";
  cursorinner.style.top = y + "px";
});

document.addEventListener("mousedown", function () {
  cursor.classList.add("click");
  cursorinner.classList.add("cursorinnerhover");
});

document.addEventListener("mouseup", function () {
  cursor.classList.remove("click");
  cursorinner.classList.remove("cursorinnerhover");
});

a.forEach((item) => {
  item.addEventListener("mouseover", () => {
    cursor.classList.add("hover");
  });
  item.addEventListener("mouseleave", () => {
    cursor.classList.remove("hover");
  });
});

document
  .querySelector(".product-card-colwrap.splide__track")
  .addEventListener("mouseover", () => {
    cursor.classList.add("show-cursor");
  });
document
  .querySelector(".product-card-colwrap.splide__track")
  .addEventListener("mouseleave", () => {
    cursor.classList.remove("show-cursor");
  });

document.addEventListener("ready", () => {
  setTimeout(function () {
    document.querySelector(".product-card-image").classList.add("show");
  }, 2000);
});

// begin white/normal home hero script
// Note: variables defined at the top of all pages script

let viewportWidth = window.innerWidth;
if (viewportWidth >= 992) {
  // leftNav.addEventListener('mouseenter', () => {
  //   if(topNav.classList.contains('white-bm-normal')) {
  //     topNav.classList.remove('white-bm-normal');
  //   }
  // });
  // leftNav.addEventListener('mouseleave', () => {
  //   const scroll = $(window).scrollTop();
  //   if(scroll == 0) {
  //     if(topNav.classList.contains('white-bm-normal') == false) {
  //       topNav.classList.add('white-bm-normal');
  //     }
  //   }
  // });
  function homeHeroAllWhite() {
    leftNav.classList.add("white-bm-normal");
    newsletterTrig.classList.add("white-bm-normal");
  }
  function homeHeroAllNormal() {
    leftNav.classList.remove("white-bm-normal");
    newsletterTrig.classList.remove("white-bm-normal");
  }
  window.addEventListener("DOMContentLoaded", homeHeroAllWhite());
  $(window).scroll(function () {
    var scroll = $(window).scrollTop();
    if (scroll > 0) {
      homeHeroAllNormal();
    } else {
      homeHeroAllWhite();
    }
  });
}
// end white/normal home hero script


// promobar swiper
const promoBarSwiper = new Swiper('.swiper-container.promo-bar', {
  autoplay: true,
  direction: 'vertical',
  slidesPerView: 1,
  centeredSlides: true,
  // spaceBetween: 15,
  threshold: 15,
  loop: true,
	speed: 800,
}); 